/**
 * A Web Component to get currency displaying correctly in Recharge
 * Usage: <localized-price data-price="{{ subscription.price }}" data-currency="{{ subscription.presentment_currency }}"></localized-price>
 */
export default class LocalizedPrice extends HTMLElement {
  constructor() {
    super();
  }

  static get observedAttributes() {
    return ["data-price", "data-currency"];
  }

  localizePrice() {
    const currency = this.dataset.currency;
    const price = Number(this.dataset.price);

    if (!currency || !price) return;

    const localizedPrice = new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currency,
    }).format(price);

    this.innerHTML = localizedPrice;
  }

  connectedCallback() {
    this.localizePrice();
  }

  attributeChangedCallback() {
    this.localizePrice();
  }
}
